export const columnOptionsData = [
  { label: 'Plantão', value: 'plantao', visible: true },
  { label: 'Empresa', value: 'empresa', visible: true },
  { label: 'Unidade de saúde', value: 'unidade', visible: true },
  { label: 'Escala', value: 'escala', visible: true },
  { label: 'Posição', value: 'posicao', visible: true },
  { label: 'Turno', value: 'turno', visible: true },
  { label: 'Médico', value: 'medico', visible: true },
  { label: 'Autorização do médico', value: 'autorizacao', visible: true },
  { label: 'Antecipação', value: 'antecipe', visible: true },
  { label: 'Status da vaga', value: 'statusVaga', visible: true },
  { label: 'Alocação', value: 'alocacao', visible: true },
  { label: 'Pagamento à vista', value: 'aVista', visible: true },
  { label: 'Política de pagamento', value: 'politica', visible: true },
  { label: 'Dados Assumidos', value: 'dadosAssumidos', visible: true },
  { label: 'Excepcionalidade', value: 'excepcionalidade', visible: true },
  { label: 'Dados de check', value: 'check', visible: true },
  { label: 'Pagamento Final', value: 'pagamentoFinal', visible: true },
  { label: 'Dados base', value: 'dados_base', visible: true },
  { label: 'Valor a pagar', value: 'valor_pagar', visible: true },
  { label: 'Observações', value: 'observacoes', visible: true }
]

export const sortOptionsData = [
  { label: 'Data do plantão crescente', value: 'date_asc', direction: 'asc', group: 'date' },
  { label: 'Data do plantão decrescente', value: 'date_desc', direction: 'desc', group: 'date' },
  { label: 'Nome do médico A-Z', value: 'name_asc', direction: 'asc', group: 'name' },
  { label: 'Nome do médico Z-A', value: 'name_desc', direction: 'desc', group: 'name' },
  { label: 'Data de criação crescente', value: 'created_asc', direction: 'asc', group: 'created' },
  {
    label: 'Data de criação decrescente',
    value: 'created_desc',
    direction: 'desc',
    group: 'created'
  }
]
